import { render, staticRenderFns } from "./detailMessageModal.vue?vue&type=template&id=5d11ba69&scoped=true"
import script from "./detailMessageModal.vue?vue&type=script&lang=js"
export * from "./detailMessageModal.vue?vue&type=script&lang=js"
import style0 from "./detailMessageModal.vue?vue&type=style&index=0&id=5d11ba69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d11ba69",
  null
  
)

export default component.exports